/* eslint-disable no-case-declarations */
import * as vitalTypes from '../types/vitalTypes';
import initialState from './initialState';
import { updateObject } from 'utils';

const vitals = (state = initialState.vitals, { type, payload }) => {
  switch (type) {
    case vitalTypes.FETCH_VITALS_START:
      return updateObject(state, { isLoading: true });

    case vitalTypes.FETCH_VITALS_SUCCESS:
      return updateObject(state, { isLoading: false, items: payload });

    case vitalTypes.FETCH_VITALS_FAIL:
      return updateObject(state, { isLoading: false });

    case vitalTypes.ADD_VITAL_SUCCESS:
      return updateObject(state, { items: [...state.items, payload] });

    case vitalTypes.ARCHIVE_VITALS_START:
      return updateObject(state, { isSaving: true });

    case vitalTypes.ARCHIVE_VITALS_END:
      return updateObject(state, { isSaving: false });

    default:
      return { ...state };
  }
};

export default vitals;
